/**
 * Challenge winner announcements – read-only (created by Cloud Functions).
 */
import { collection, query, orderBy, limit, onSnapshot, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { createChallengeWinnerAnnouncement } from '../../domain/entities/ChallengeWinnerAnnouncement';

const COLLECTION = 'challengeWinnerAnnouncements';

export function subscribeLatestWinnerAnnouncements(limitCount, onUpdate) {
  const q = query(
    collection(db, COLLECTION),
    orderBy('announcedAt', 'desc'),
    limit(limitCount)
  );
  return onSnapshot(q, (snap) => {
    const items = snap.docs.map((d) => createChallengeWinnerAnnouncement({ id: d.id, ...d.data() }));
    onUpdate(items);
  });
}

export async function getLatestWinnerAnnouncements(limitCount = 5) {
  const q = query(
    collection(db, COLLECTION),
    orderBy('announcedAt', 'desc'),
    limit(limitCount)
  );
  const snap = await getDocs(q);
  return snap.docs.map((d) => createChallengeWinnerAnnouncement({ id: d.id, ...d.data() }));
}
